import { FC, memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from 'src/utils/helpers';

const SkeletonsColumn: FC = (): JSX.Element => {
  return (
    <div className="d-flex align-items-center mb-4">
      <Skeleton className="d-flex flex-column mr-8" width={80} height={20} />
      <Skeleton className="d-flex flex-column" width={240} height={45} />
    </div>
  );
};

const CheckoutPreloadingSkeletons: FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-column px-4">
      <Skeleton className="mr-8 mb-4" width={160} style={{ borderRadius: 15 }} count={3} height={35} />
      <div className="d-flex flex-column">
        {emptyArray(4).map((_, index) => (
          <SkeletonsColumn key={String(index) + '-checkout-skeleton'} />
        ))}
      </div>
    </div>
  );
};

export default memo(CheckoutPreloadingSkeletons);
